<div class="container">
    <div class="row col-xs-6">
        <form>
            <div class="form-group">
                <label for="inputUsername" class="col-sm-4 control-label">Username</label>
                <input type="text" [(ngModel)]="name" name="name" class="form-control" id="inputUsername" placeholder="User Name">
            </div>
            <div class="form-group">
                <label for="inputPassword3" class="col-sm-4 control-label">Password</label>
                <input type="password" [(ngModel)]="password" name="password" class="form-control" id="inputPassword3" placeholder="Password">
            </div>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-8">
                    <div class="checkbox">
                        <label>
                            <input [(ngModel)]="rememberMe" name="checkbox" type="checkbox"> Remember me
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="!!error" class="login-form-button heigt30 alert-danger">
                <span class="fa fa-exclamation-triangle"></span> {{ error }}
            </div>
            <br/>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <input type="button" class="btn btn-success" (click)="login()" value="Login" />
                    <a routerLink="/signup">Don't have an account? Register</a>
                </div>
            </div>
        </form>
    </div>
</div>
